import {
  IDuTruHocBongRequest,
  ITyLeHocBongSaveRequest,
} from "../../../model/request/bao-cao/IDuTruHocBongRequest";
import {
  IDuTruHocBongKetQua,
  ITyLeHocBong,
} from "../../../model/respone/bao-cao/IDuTruHocBong";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eDuTruHocBongActionsObj = {
  CHANGE_REQUEST: {} as Partial<IDuTruHocBongRequest>,

  LOAD_START: {} as IDuTruHocBongRequest,
  LOAD_SUCCESS: {} as IDuTruHocBongKetQua,
  LOAD_ERROR: "",

  /** Tỷ lệ % đã khai của học kỳ. */
  LOAD_TY_LE_START: {} as { hoc_ky: number; nam_hoc: string },
  LOAD_TY_LE_SUCCESS: {} as ITyLeHocBong | undefined,

  SAVE_TY_LE_START: {} as ITyLeHocBongSaveRequest,
  SAVE_TY_LE_SUCCESS: {} as ITyLeHocBong | undefined,
  SAVE_TY_LE_ERROR: "",

  EXPORT_EXCEL_START: {} as IDuTruHocBongRequest,
  EXPORT_EXCEL_SUCCESS: "",
  EXPORT_EXCEL_ERROR: "",

  /** Xem trước bản in (HTML dựng từ chính tệp Excel sẽ xuất) để in PDF. */
  XEM_TRUOC_START: {} as IDuTruHocBongRequest,
  XEM_TRUOC_SUCCESS: "",
  XEM_TRUOC_ERROR: "",
  DONG_XEM_TRUOC: undefined,
};

export const eDuTruHocBongActionIds = generateActionTypeIds(
  eDuTruHocBongActionsObj,
  "DU_TRU_HOC_BONG",
);

export type IDuTruHocBongActionTypes = IGenericActionType<
  typeof eDuTruHocBongActionsObj,
  "DU_TRU_HOC_BONG"
>;
